import { useTranslation } from "react-i18next";
import { ColumnDirective, ColumnsDirective, GridComponent, Page, Inject, Edit } from "@syncfusion/ej2-react-grids";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { FaEdit, FaLink, FaExclamationTriangle, FaTrash, FaMapMarkerAlt } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { controlService } from "../../Services/control.service";
import { vehicleGroupService } from "../../Services/vehicle.group.service";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import ToastError from "../Components/ToastError";
import { ToastComponent } from "../Components/ToastComponent";
import { Filters } from "../../components/Filters";
import { useSelected } from "../../contexts/SelectedContext";
import { HiOutlineRectangleGroup } from "react-icons/hi2";
import { getLocationCoordinates } from "../../Services/locations.service";


export default function PolygonFences({ apiKey }) {
  const { t } = useTranslation();
    const dispatch = useDispatch();
    dispatch({ type: "title", value: "Cerca Poligonal" });
    const mapRef = useRef(null);
    const inputRef = useRef(null);
    const [mapReady, setMapReady] = useState(false);
    // drawingManagerRef REMOVIDO — DrawingManager foi descontinuado na API v3.65
    const activePolygonRef = useRef(null);
    const preserveViewModeRef = useRef(false);
    const autocompleteRef = useRef(null);
    const geocoderRef = useRef(null);
    const lastPlaceRef = useRef(null);
    const [activeTab, setActiveTab] = useState("grid");
    const [coordinatesList, setCoordinatesList] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [markerDescription, setMarkerDescription] = useState("");
    const [pageSize, setPageSize] = useState(10);

    const [showToast, setShowToast] = useState(false);
    const [toastParams, setToastParams] = useState('');

    const [showModalEdit, setShowModalEdit] = useState(false);
    const [selectedBindMarker, setSelectedBindMarker] = useState(null);

    const [showModalControl, setShowModalControl] = useState(false);
    const [loading, setLoading] = useState(false);
    const gridRef = useRef(null);
    const [bindList, setBindList] = useState([]);
    const [vehicleGroups, setVehicleGroups] = useState([]);
    const [selectedVehicleIds, setSelectedVehicleIds] = useState([]);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [riskToDelete, setRiskToDelete] = useState(null);
    const [editingItem, setEditingItem] = useState(null);

    const [isViewMode, setIsViewMode] = useState(false);
    const [viewingItem, setViewingItem] = useState(null);
    const [savingPolygon, setSavingPolygon] = useState(false);
    const editingItemRef = useRef(null);

    // Estado para modo de desenho manual (substitui DrawingManager)
    const [isDrawingMode, setIsDrawingMode] = useState(false);
    const drawingPointsRef = useRef([]);       // pontos clicados durante o desenho
    const tempMarkersRef = useRef([]);         // marcadores visuais dos pontos
    const tempPolylineRef = useRef(null);      // linha temporária durante o desenho
    const mapInstanceRef = useRef(null);       // referência ao objeto Map do Google
    const clickListenerRef = useRef(null);     // listener de clique no mapa

    const [isEditing, setIsEditing] = useState(true);

    const handleParamEdit = (row) => {
        handleViewOnMap(row);
    };

    const handleEnableEditing = () => {
        if (viewingItem) {
            setEditingItem({
                ...viewingItem,
                markerDescription: viewingItem.markerDescription || "",
                latitude: Number(viewingItem.latitude),
                longitude: Number(viewingItem.longitude),
                address: viewingItem.address || viewingItem.location || "",
                markerTypeId: 8,
                markerId: viewingItem.markerId,
            });
            setViewingItem(null);
            setIsViewMode(false);
        }
        setIsEditing(true);

        setTimeout(() => {
            const chk = document.getElementById("chkEdit");
            if (chk) chk.checked = true;
        }, 100);

        if (activePolygonRef.current) {
            activePolygonRef.current.setEditable(true);
            activePolygonRef.current.setDraggable(true);
        }
    };

    const { selectedValues } = useSelected();
    const selectedGroup = selectedValues.gruposModal?.[0] || 0;

    useEffect(() => {
        if (showModalControl) {
            const fetchGroups = async () => {
                try {
                    const groups = await vehicleGroupService.fetchGroups();
                    setVehicleGroups(groups || []);
                } catch (error) {
                    console.error("Erro ao buscar grupos:", error);
                }
            };
            fetchGroups();
        }
    }, [showModalControl]);

    useEffect(() => {
        if (!selectedBindMarker) return;

        const fetchBindsData = async () => {
            try {
                const vehicleGroupId = selectedGroup && selectedGroup !== "0" && selectedGroup !== "TODOS" ? selectedGroup : null;
                const response = await controlService.fetchBindPointControl(
                    selectedBindMarker.markerTypeId,
                    selectedBindMarker.markerId,
                    vehicleGroupId
                );

                if (response) {
                    setBindList(response);
                    const alreadyLinked = response
                        .filter(item => item.markerId && item.markerId > 0)
                        .map(item => item.vehicleId);
                    setSelectedVehicleIds(alreadyLinked);
                }
            } catch (error) {
                console.error(error);
            }
        };

        fetchBindsData();
    }, [selectedBindMarker, showModalControl, selectedGroup]);

    const onBindCheckboxChange = (checked, vehicleId) => {
        if (checked) {
            setSelectedVehicleIds(prev =>
                prev.includes(vehicleId) ? prev : [...prev, vehicleId]
            );
        } else {
            setSelectedVehicleIds(prev => prev.filter(id => id !== vehicleId));
        }
    };

    const bindCheckboxTemplate = (props) => {
        const isChecked = selectedVehicleIds.includes(props.vehicleId);
        return (
            <input
                type="checkbox"
                checked={isChecked}
                onChange={(e) => onBindCheckboxChange(e.target.checked, props.vehicleId)}
            />
        );
    };

    const handleSaveBindings = async () => {
        if (!selectedBindMarker) {
            setToastParams(
                JSON.stringify({
                    show: true,
                    title: "Atenção",
                    body: "Nenhum marcador selecionado.",
                    color: "Warning",
                })
            );
            return;
        }

        setLoading(true);
        try {
            const markerTypeId = selectedBindMarker.markerTypeId;
            const vehiclesToBind = selectedVehicleIds;
            const allVehicleIds = bindList.map(item => item.vehicleId);
            const vehiclesToUnbind = allVehicleIds.filter(id => !selectedVehicleIds.includes(id));

            const promises = [];

            const bindPayload = {
                listVehicleId: vehiclesToBind,
                markerId: selectedBindMarker.markerId,
                markerTypeId: markerTypeId,
            };
            promises.push(controlService.bindPointControl(bindPayload));

            if (vehiclesToUnbind.length > 0) {
                const unbindPayload = {
                    listVehicleId: vehiclesToUnbind,
                    markerId: selectedBindMarker.markerId,
                    markerTypeId: markerTypeId,
                };
                promises.push(controlService.unbindPointControl(unbindPayload));
            }

            const responses = await Promise.all(promises);
            const hasError = responses.some(res => !res || res.error);

            if (!hasError) {
                const totalChanges = vehiclesToBind.length + vehiclesToUnbind.length;
                await controlService.updateMarkers();
                setToastParams(
                    JSON.stringify({
                        show: true,
                        title: "Sucesso",
                        body: `${totalChanges} alteração(ões) salva(s) com sucesso.`,
                        color: "Success",
                    })
                );

                setSelectedVehicleIds([]);
                setShowModalControl(false);
            } else {
                const body =
                    responses.find(r => r?.message)?.message ||
                    responses.find(r => r?.friendlyMessage)?.friendlyMessage ||
                    "Não foi possível salvar as alterações.";
                setToastParams(JSON.stringify({ show: true, title: "Erro", body, color: "Danger" }));
            }
        } catch (error) {
            console.error("Erro ao salvar vinculações:", error);
            setToastParams(JSON.stringify({ show: true, title: "Erro", body: "Falha na requisição.", color: "Danger" }));
        } finally {
            setLoading(false);
        }
    };

    const fetchCoordinates = async () => {
        try {
            const response = await controlService.findCoordinate(8);
            if (Array.isArray(response)) setCoordinatesList(response);
        } catch (error) {
            console.error("Erro ao buscar coordenadas:", error);
        }
    };

    useEffect(() => {
        fetchCoordinates();
    }, []);

    useEffect(() => {
        if (window.google && window.google.maps) {
            setMapReady(true);
            return;
        }

        const id = "gmaps-script";
        if (document.getElementById(id)) {
            const check = setInterval(() => {
                if (window.google && window.google.maps) {
                    clearInterval(check);
                    setMapReady(true);
                }
            }, 200);
            return () => clearInterval(check);
        }

        const script = document.createElement("script");
        script.id = id;
        // "drawing" REMOVIDO — foi descontinuado na API v3.65
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&v=quarterly&libraries=places`;
        script.async = true;
        script.defer = true;
        script.onload = () => setMapReady(true);
        script.onerror = () => console.error("Google Maps script failed to load");
        document.head.appendChild(script);

        return () => {};
    }, [apiKey]);

    const loadEditingData = async (item, map, forceEditingMode = null) => {
        if (!map || !item) return;
        editingItemRef.current = item;

        console.log("Carregando dados de edição:", item, "forceEditingMode:", forceEditingMode);

        clearPolygon();

        let coordinates;
        try {
            const markerId = item.markerId;
            const response = await controlService.findPolygon(markerId);
            const areaString = response.area.replace(/\*/g, '"');
            coordinates = JSON.parse(areaString);
            console.log("Coordenadas parseadas:", coordinates);
        } catch (e) {
            console.error("Erro ao ler coordenadas do item:", e);
            setToastParams(JSON.stringify({
                show: true,
                title: "Erro",
                body: 'Erro ao carregar as coordenadas da área.',
                color: 'danger'
            }));
            return;
        }

        if (!coordinates || coordinates.length < 3) {
            console.error("Coordenadas insuficientes:", coordinates);
            setToastParams(JSON.stringify({
                show: true,
                title: "Erro",
                body: 'Área com coordenadas insuficientes.',
                color: 'danger'
            }));
            return;
        }

        const googleCoords = coordinates.map(coord =>
            new window.google.maps.LatLng(coord.lat, coord.lng)
        );

        const isEditingMode = forceEditingMode !== null ? forceEditingMode : (!!editingItem && !isViewMode);
        const polygon = new window.google.maps.Polygon({
            paths: googleCoords,
            map: map,
            editable: isEditingMode,
            draggable: isEditingMode,
            strokeColor: "#1f1f1f",
            strokeOpacity: 0.8,
            strokeWeight: 3,
            fillColor: "#66a3ff",
            fillOpacity: 0.35,
        });

        activePolygonRef.current = polygon;

        const chk = document.getElementById("chkEdit");
        const btnCopy = document.getElementById("btnCopy");
        const btnClear = document.getElementById("btnClear");

        const isViewModeNow = forceEditingMode !== null ? !forceEditingMode : isViewMode;

        if (chk) {
            chk.disabled = isViewModeNow;
            chk.checked = isEditingMode;
        }
        if (btnCopy) btnCopy.disabled = isViewModeNow;
        if (btnClear) btnClear.disabled = isViewModeNow;

        const bounds = new window.google.maps.LatLngBounds();
        googleCoords.forEach(coord => bounds.extend(coord));
        map.fitBounds(bounds, { top: 50, right: 50, bottom: 50, left: 50 });

        setMarkerDescription(item.markerDescription || "");

        if (inputRef.current) {
            inputRef.current.value = item.address || "";
        }

        if (isEditingMode) {
            polygon.addListener("mouseup", () => updatePolygonCoordinates(polygon));
            polygon.addListener("dragend", () => updatePolygonCoordinates(polygon));
        }

        console.log("Polígono de edição carregado com sucesso");
    };

    const editingCoordinatesRef = useRef(null);

    const updatePolygonCoordinates = (polygon) => {
        const newPaths = polygon.getPaths();
        const newCoordinates = [];

        newPaths.forEach(path => {
            path.forEach(latLng => {
                newCoordinates.push({
                    lat: +latLng.lat().toFixed(7),
                    lng: +latLng.lng().toFixed(7)
                });
            });
        });

        editingCoordinatesRef.current = newCoordinates;
        console.log("Coordenadas temporárias atualizadas:", newCoordinates);
    };

    // ─── Desenho manual de polígono (substitui DrawingManager) ───────────────

    const stopDrawingMode = () => {
        const map = mapInstanceRef.current;
        if (!map) return;

        // Remove listener de clique
        if (clickListenerRef.current) {
            window.google.maps.event.removeListener(clickListenerRef.current);
            clickListenerRef.current = null;
        }

        // Remove marcadores temporários
        tempMarkersRef.current.forEach(m => m.setMap(null));
        tempMarkersRef.current = [];

        // Remove linha temporária
        if (tempPolylineRef.current) {
            tempPolylineRef.current.setMap(null);
            tempPolylineRef.current = null;
        }

        drawingPointsRef.current = [];
        setIsDrawingMode(false);

        if (map.getDiv()) {
            map.getDiv().style.cursor = "";
        }
    };

    const finalizePolygon = (points) => {
        const map = mapInstanceRef.current;
        if (!map || points.length < 3) return;

        stopDrawingMode();

        const polygon = new window.google.maps.Polygon({
            paths: points,
            map: map,
            editable: true,
            draggable: true,
            strokeColor: "#1f1f1f",
            strokeOpacity: 0.9,
            strokeWeight: 2,
            fillColor: "#66a3ff",
            fillOpacity: 0.25,
        });

        // Salva coordenadas iniciais
        editingCoordinatesRef.current = points.map(p => ({
            lat: +p.lat().toFixed(7),
            lng: +p.lng().toFixed(7),
        }));

        polygon.addListener("mouseup", () => updatePolygonCoordinates(polygon));
        polygon.addListener("dragend", () => updatePolygonCoordinates(polygon));

        setActivePolygon(polygon);
    };

    const startDrawingMode = () => {
        const map = mapInstanceRef.current;
        if (!map) return;

        // Limpa qualquer polígono anterior
        clearPolygon();

        drawingPointsRef.current = [];
        setIsDrawingMode(true);

        if (map.getDiv()) {
            map.getDiv().style.cursor = "crosshair";
        }

        // Linha temporária que acompanha os cliques
        const polyline = new window.google.maps.Polyline({
            map,
            strokeColor: "#1f1f1f",
            strokeOpacity: 0.8,
            strokeWeight: 2,
        });
        tempPolylineRef.current = polyline;

        clickListenerRef.current = map.addListener("click", (e) => {
            const latLng = e.latLng;
            const points = drawingPointsRef.current;

            // Se clicou perto do primeiro ponto (≤ 20px) e já tem 3+ pontos → fecha o polígono
            if (points.length >= 3) {
                const firstPoint = points[0];
                const scale = Math.pow(2, map.getZoom());
                const proj = map.getProjection();

                if (proj) {
                    const p1 = proj.fromLatLngToPoint(firstPoint);
                    const p2 = proj.fromLatLngToPoint(latLng);
                    const pixelDist = Math.sqrt(
                        Math.pow((p1.x - p2.x) * scale, 2) +
                        Math.pow((p1.y - p2.y) * scale, 2)
                    );

                    if (pixelDist < 20) {
                        finalizePolygon(points);
                        return;
                    }
                }
            }

            // Adiciona o ponto
            points.push(latLng);
            drawingPointsRef.current = [...points];

            // Marcador visual pequeno no ponto
            const dot = new window.google.maps.Marker({
                position: latLng,
                map,
                icon: {
                    path: window.google.maps.SymbolPath.CIRCLE,
                    scale: points.length === 1 ? 7 : 4,
                    fillColor: points.length === 1 ? "#ff0000" : "#1f1f1f",
                    fillOpacity: 1,
                    strokeWeight: 1,
                    strokeColor: "#ffffff",
                },
                title: points.length === 1 ? "Clique aqui para fechar o polígono" : "",
            });
            tempMarkersRef.current.push(dot);

            // Atualiza a polyline
            polyline.setPath(points);
        });
    };

    // ─────────────────────────────────────────────────────────────────────────

    useEffect(() => {
        if (activeTab === "map") {
            if (!mapReady) return;
            if (!mapRef.current) return;

            const google = window.google;

            const map = new google.maps.Map(mapRef.current, {
                center: { lat: -23.55052, lng: -46.63331 },
                zoom: 12,
                streetViewControl: false,
                mapTypeControl: false,
                clickableIcons: false,
            });

            mapInstanceRef.current = map;
            mapRef.current._map = map;

            geocoderRef.current = new google.maps.Geocoder();

            autocompleteRef.current = new google.maps.places.Autocomplete(inputRef.current, {
                fields: ["geometry", "name", "formatted_address"],
                componentRestrictions: { country: ["br"] },
            });
            autocompleteRef.current.bindTo("bounds", map);
            autocompleteRef.current.addListener("place_changed", () => {
                const place = autocompleteRef.current.getPlace();
                if (!place || !place.geometry) return;
                lastPlaceRef.current = place;
                centerOnPlace(place, map);
            });

            if (editingItem && !activePolygonRef.current) {
                setTimeout(() => {
                    const forceEditingMode = !!editingItem && !isViewMode;
                    loadEditingData(editingItem, map, forceEditingMode);
                }, 500);
            }

            setTimeout(() => {
                if (map) google.maps.event.trigger(map, 'resize');
            }, 100);

            const handleResize = () => {
                if (map) google.maps.event.trigger(map, 'resize');
            };
            window.addEventListener('resize', handleResize);

            return () => {
                if (autocompleteRef.current) google.maps.event.clearInstanceListeners(autocompleteRef.current);
                stopDrawingMode();
                window.removeEventListener('resize', handleResize);
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mapReady, activeTab, editingItem]);

    useEffect(() => {
        if (activeTab === "map" && editingItem && mapRef.current?._map && activePolygonRef.current) {
            console.log("Atualizando dados de edição...");
            const forceEditingMode = !!editingItem && !isViewMode;
            loadEditingData(editingItem, mapRef.current._map, forceEditingMode);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editingItem, isViewMode, activeTab]);

    useEffect(() => {
        if (!activePolygonRef.current) return;

        const handlePolygonChange = () => {
            updatePolygonCoordinates(activePolygonRef.current);
        };

        const listener = window.google.maps.event.addListener(
            activePolygonRef.current,
            'dragend',
            handlePolygonChange
        );

        const listenerPath = window.google.maps.event.addListener(
            activePolygonRef.current.getPath(),
            'set_at',
            handlePolygonChange
        );

        return () => {
            window.google.maps.event.removeListener(listener);
            window.google.maps.event.removeListener(listenerPath);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activePolygonRef.current]);

    const calculatePageSize = () => {
        const windowHeight = window.innerHeight;
        const totalFixedHeight = 60 + 30 + 50 + 35 + 30;
        const availableHeight = windowHeight - totalFixedHeight;
        const calculatedPageSize = Math.max(Math.floor(availableHeight / 38), 10);
        setPageSize(calculatedPageSize);
    };

    useLayoutEffect(() => {
        calculatePageSize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [window.location.pathname]);

    useEffect(() => {
        let timeoutId;
        const handleResize = () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => calculatePageSize(), 300);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
            clearTimeout(timeoutId);
        };
    }, []);

    function centerOnPlace(place, map) {
        if (!map) map = mapRef.current && mapRef.current._map;
        if (!map || !place) return;
        if (place.geometry.viewport) {
            map.fitBounds(place.geometry.viewport);
        } else if (place.geometry.location) {
            map.setCenter(place.geometry.location);
            map.setZoom(14);
        }
    }

    function handleSearch() {
        const txt = inputRef.current.value.trim();
        const map = mapRef.current._map;

        if (lastPlaceRef.current && lastPlaceRef.current.geometry) {
            map.setCenter(lastPlaceRef.current.geometry.location);
            return;
        }

        if (!txt) return;

        geocoderRef.current.geocode({ address: txt }, (results, status) => {
            if (status === "OK" && results && results[0]) {
                map.setCenter(results[0].geometry.location);
            } else {
                setToastParams(JSON.stringify({
                    show: true,
                    title: "Erro",
                    body: 'Local não encontrado',
                    color: 'danger'
                }));
            }
        });
    }

    function handleDraw() {
        startDrawingMode();
    }

    function setActivePolygon(polygon) {
        if (activePolygonRef.current && !editingItem) {
            activePolygonRef.current.setMap(null);
        }

        activePolygonRef.current = polygon;

        const chk = document.getElementById("chkEdit");
        if (chk) {
            chk.disabled = false;
            chk.checked = true;
        }

        const btnCopy = document.getElementById("btnCopy");
        const btnClear = document.getElementById("btnClear");
        if (btnCopy) btnCopy.disabled = false;
        if (btnClear) btnClear.disabled = false;

        if (!editingItem) {
            polygon.addListener("click", () => {
                const now = !polygon.getEditable();
                polygon.setEditable(now);
                const chk = document.getElementById("chkEdit");
                if (chk) chk.checked = now;
            });
        }
    }

    function clearPolygon() {
        // Para o modo de desenho se estiver ativo
        if (isDrawingMode) stopDrawingMode();

        if (activePolygonRef.current) {
            activePolygonRef.current.setMap(null);
            activePolygonRef.current = null;
        }

        if (!editingItem && !isViewMode) {
            setEditingItem(null);
            setMarkerDescription("");
        }

        const chk = document.getElementById("chkEdit");
        if (chk) {
            chk.disabled = true;
            chk.checked = false;
        }

        const btnCopy = document.getElementById("btnCopy");
        const btnClear = document.getElementById("btnClear");
        if (btnCopy) btnCopy.disabled = true;
        if (btnClear) btnClear.disabled = true;

        if (inputRef.current && !editingItem && !isViewMode && !viewingItem) {
            inputRef.current.value = "";
        }

        if (preserveViewModeRef.current) {
            preserveViewModeRef.current = false;
        } else if (!viewingItem) {
            setIsViewMode(false);
        }
    }

    useEffect(() => {
        if (activeTab !== "map") {
            setIsViewMode(false);
            setEditingItem(null);
            setViewingItem(null);
        } else if (activeTab === "map" && !editingItem && !viewingItem) {
            clearPolygon();
            setMarkerDescription("");
            if (inputRef.current) inputRef.current.value = "";
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab]);

    async function handleSavePolygon() {
        setSavingPolygon(true);
        try {
            const polygon = activePolygonRef.current;
            if (!polygon) {
                setToastParams(JSON.stringify({ show: true, title: "Erro", body: 'Desenhe uma área antes de salvar.', color: 'danger' }));
                setSavingPolygon(false);
                return;
            }

            if (!markerDescription.trim()) {
                setToastParams(JSON.stringify({ show: true, title: "Erro", body: 'Digite uma descrição para a área.', color: 'danger' }));
                setSavingPolygon(false);
                return;
            }

            const coords = editingCoordinatesRef.current || [];

            if (coords.length === 0 && polygon) {
                const paths = polygon.getPaths();
                const currentCoords = [];
                paths.forEach(path => {
                    path.forEach(latLng => {
                        currentCoords.push({
                            lat: +latLng.lat().toFixed(7),
                            lng: +latLng.lng().toFixed(7)
                        });
                    });
                });
                editingCoordinatesRef.current = currentCoords;
            }

            const finalCoords = editingCoordinatesRef.current || [];

            if (finalCoords.length < 3) {
                setToastParams(JSON.stringify({ show: true, title: "Erro", body: 'O polígono precisa ter ao menos 3 pontos.', color: 'danger' }));
                setSavingPolygon(false);
                return;
            }

            let latSum = 0;
            let lngSum = 0;
            finalCoords.forEach(coord => {
                latSum += coord.lat;
                lngSum += coord.lng;
            });

            const center = {
                lat: latSum / finalCoords.length,
                lng: lngSum / finalCoords.length,
            };

            const address = await new Promise((resolve) => {
                geocoderRef.current.geocode({ location: center }, (results, status) => {
                    if (status === "OK" && results[0]) resolve(results[0].formatted_address);
                    else resolve("Endereço não encontrado");
                });
            });

            let payload;
            let response;

            if (editingItem) {
                payload = {
                    markerTypeId: 8,
                    markerId: editingItem.markerId,
                    markerDescription: markerDescription.trim(),
                    latitude: center.lat,
                    longitude: center.lng,
                    address,
                    destinationLatitude: center.lat,
                    destinationLongitude: center.lng,
                    destinationAddress: address,
                    radius: 0,
                    area: JSON.stringify(finalCoords),
                };
                response = await controlService.updateCoordinate(payload);
            } else {
                payload = {
                    markerTypeId: 8,
                    markerDescription: markerDescription.trim(),
                    latitude: center.lat,
                    longitude: center.lng,
                    address,
                    destinationLatitude: center.lat,
                    destinationLongitude: center.lng,
                    destinationAddress: address,
                    radius: 0,
                    area: JSON.stringify(finalCoords),
                };
                response = await controlService.createFences(payload);
            }

            if (response) {
                setToastParams(JSON.stringify({
                    show: true,
                    title: "Sucesso",
                    body: editingItem ? "Área atualizada com sucesso!" : "Área salva com sucesso!",
                    color: "Success"
                }));
                setShowModal(false);
                await fetchCoordinates();
                setMarkerDescription("");
                preserveViewModeRef.current = false;
                setEditingItem(null);
                setViewingItem(null);
                setIsViewMode(false);
                clearPolygon();
                setActiveTab("grid");
            }

        } catch (e) {
            console.error("Erro ao salvar a área:", e);
            setToastParams(JSON.stringify({
                show: true,
                title: "Erro",
                body: `Erro ao ${editingItem ? 'atualizar' : 'salvar'} a área. Tente novamente.`,
                color: 'danger'
            }));
        } finally {
            setSavingPolygon(false);
        }
    }

    const handleViewOnMap = async (row) => {
        const viewable = {
            ...row,
            markerDescription: row.markerDescription || "",
            latitude: Number(row.latitude),
            longitude: Number(row.longitude),
            address: row.address || row.location || "",
            markerTypeId: 8,
            markerId: row.markerId,
        };

        setEditingItem(null);
        setViewingItem(viewable);
        setIsViewMode(true);
        setIsEditing(false);
        setActiveTab("map");

        setTimeout(() => {
            if (!mapRef.current || !mapRef.current._map) return;
            const map = mapRef.current._map;
            if (inputRef.current) {
                inputRef.current.value = viewable.address || viewable.location || "";
            }
            loadEditingData(viewable, map, false);
        }, 500);
    };

    const onSubmitModalEdit = async () => {
        if (!selectedBindMarker) {
            console.error("Nenhum marcador selecionado para edição.");
            return;
        }

        const payload = {
            markerTypeId: 8,
            markerId: selectedBindMarker.markerId,
            markerDescription: selectedBindMarker.markerDescription || "Cerca eletrônica gerada pelo mapa",
            latitude: selectedBindMarker.latitude,
            longitude: selectedBindMarker.longitude,
            address: selectedBindMarker.address,
            destinationLatitude: selectedBindMarker.latitude,
            destinationLongitude: selectedBindMarker.longitude,
            destinationAddress: selectedBindMarker.address,
            area: selectedBindMarker.area || 0,
        };

        try {
            const response = await controlService.updateCoordinate(payload);
            if (response) {
                setToastParams(
                    JSON.stringify({
                        show: true,
                        title: "Cerca Atualizada",
                        body: "Cerca eletrônica atualizada com sucesso",
                        color: "success",
                    })
                );
                await fetchCoordinates();
            } else {
                setToastParams(
                    JSON.stringify({
                        show: true,
                        title: "Erro",
                        body: "Erro ao atualizar área eletrônica",
                        color: "danger",
                    })
                );
            }
        } catch (error) {
            console.error("Erro ao atualizar coordenada:", error);
            setToastParams(
                JSON.stringify({
                    show: true,
                    title: "Erro",
                    body: "Erro ao atualizar área eletrônica",
                    color: "danger",
                })
            );
        } finally {
            setShowToast(true);
            setShowModalEdit(false);
        }
    };

    function flashMsg(text) {
        const el = document.getElementById("msg");
        if (!el) return;
        el.textContent = text;
        el.style.display = "block";
        setTimeout(() => (el.style.display = "none"), 1200);
    }

    function handleToggleEdit(e) {
        if (activePolygonRef.current) activePolygonRef.current.setEditable(e.target.checked);
    }

    const openDeleteModal = (area) => {
        setRiskToDelete(area);
        setShowConfirmModal(true);
    };

    const confirmDelete = async () => {
        try {
            const response = await controlService.deleteAddress(
                riskToDelete.markerId,
                riskToDelete.markerTypeId
            );

            if (response?.status === 400) {
                setToastParams(
                  JSON.stringify({
                    show: true,
                    title: response.friendlyMessage,
                    body: response.message,
                    color: "Warning",
                  })
                );
            } else if (response.status === 204 || response.status === 200) {
                setToastParams(
                    JSON.stringify({
                        show: true,
                        title: "Sucesso",
                        body: "Área excluída com sucesso.",
                        color: "Success",
                    })
                );
            } else {
                setToastParams(
                    JSON.stringify({
                        show: true,
                        title: "Erro",
                        body: "Não foi possível excluir a area.",
                        color: "Danger",
                    })
                );
            }
        } catch (error) {
            console.error("Erro ao excluir a area:", error);

            if (error?.response?.status === 409) {
                setToastParams(
                    JSON.stringify({
                        show: true,
                        title: "Não permitido",
                        body: "Esta area possui veículos vinculados e não pode ser excluída.",
                        color: "Warning",
                    })
                );
            } else {
                setToastParams(
                    JSON.stringify({
                        show: true,
                        title: "Erro",
                        body: "Falha inesperada ao excluir.",
                        color: "Danger",
                    })
                );
            }
        } finally {
            setShowConfirmModal(false);
            setRiskToDelete(null);
            setTimeout(async () => {
                await fetchCoordinates();
            }, 500);
        }
    };

    return (
        <>
            {showToast && (
                <ToastError
                    message="Erro ao calcular rota. Verifique se os pontos de origem e destino estão definidos."
                    onClose={() => setShowToast(false)}
                />
            )}

            <ToastComponent params={toastParams} closeToast={() => setToastParams(JSON.stringify({ show: false }))} />

            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {editingItem ? t("RISK_AREA.UPDATE_AREA") : t("RISK_AREA.SAVE_AREA")}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form.Group className="mb-3" controlId="markerDescription">
                        <Form.Label>{t("RISK_AREA.POLYGON_DESCRIPTION")}:</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Ex: Área de risco - Zona Norte"
                            value={markerDescription}
                            onChange={(e) => setMarkerDescription(e.target.value)}
                            maxLength={100}
                        />
                        {editingItem && (
                            <Form.Text className="text-muted">
                                Editando: {editingItem.markerDescription}
                            </Form.Text>
                        )}
                    </Form.Group>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)} disabled={savingPolygon}>
                        {t("RISK_AREA.CANCEL")}
                    </Button>
                    <Button variant="primary" onClick={handleSavePolygon} disabled={savingPolygon}>
                        {savingPolygon ? (
                            <>
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    className="me-2"
                                />
                                {t("RISK_AREA.SAVING")}
                            </>
                        ) : (
                            editingItem ? t("BUTTONS.UPDATE", "Atualizar") : t("BUTTONS.SAVE")
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showModalEdit} onHide={() => setShowModalEdit(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{t("RISK_AREA.EDIT")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedBindMarker && (
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label>{t("COMMON.NAME")}:</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={selectedBindMarker.markerDescription}
                                    onChange={(e) =>
                                        setSelectedBindMarker({ ...selectedBindMarker, markerDescription: e.target.value })
                                    }
                                />
                            </Form.Group>
                        </Form>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModalEdit(false)}>
                        {t("RISK_AREA.CANCEL")}
                    </Button>
                    <Button variant="primary" onClick={() => onSubmitModalEdit()}>
                        {t("RISK_AREA.SAVE")}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showModalControl} onHide={() => setShowModalControl(false)} size="lg" scrollable>
                <Modal.Header
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "start",
                        textAlign: "left",
                    }}
                >
                    <Modal.Title>{t("RISK_AREA.BIND_VEHICLES")}</Modal.Title>
                    <p>Para que você possa excluir uma cerca poligonal, ele não pode ter nenhum veículo vinculado</p>

                    <div style={{ display: "flex", gap: 16, alignItems: "flex-end", marginTop: 15, marginBottom: 10 }}>
                        <div style={{ flex: 1 }}>
                            <Filters
                                id={"gruposModal"}
                                isMulti={false}
                                title={"Grupos"}
                                pageTitle={"RiskArea"}
                                hasSubTitle={true}
                                subTitle={"Todos os grupos"}
                                options={vehicleGroups || []}
                                icon={HiOutlineRectangleGroup}
                                hasIcon={true}
                            />
                        </div>

                        <div style={{ display: "flex", gap: 8 }}>
                            <Button
                                variant="primary"
                                onClick={() => {
                                    const allIds = bindList.map((item) => item.vehicleId);
                                    setSelectedVehicleIds(allIds);
                                }}
                            >
                                Selecionar Todos
                            </Button>

                            <Button
                                variant="secondary"
                                onClick={() => setSelectedVehicleIds([])}
                            >
                                Remover Todos
                            </Button>
                        </div>
                    </div>
                </Modal.Header>

                <Modal.Body>
                    {loading && <p>Processando...</p>}
                    {bindList.length === 0 ? (
                        <p style={{ textAlign: "center", fontWeight: "500", padding: "20px 0" }}>
                            Nenhum veículo encontrado para este ponto.
                        </p>
                    ) : (
                        <GridComponent
                            ref={gridRef}
                            dataSource={bindList}
                            allowPaging={false}
                            cssClass="custom-grid-control"
                            selectionSettings={{ type: "Multiple" }}
                        >
                            <ColumnsDirective>
                                <ColumnDirective field="licensePlate" headerText={t("COMMON.PLATE")} width="120" textAlign="Center" />
                                <ColumnDirective
                                    headerText="Vincular"
                                    width="60"
                                    textAlign="Center"
                                    template={bindCheckboxTemplate}
                                />
                                <ColumnDirective field="markerStatusDescription" headerText="Status" width="100" textAlign="Center" />
                            </ColumnsDirective>
                            <Inject services={[Edit]} />
                        </GridComponent>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="primary" onClick={handleSaveBindings} disabled={loading}>
                        {t("RISK_AREA.SAVE")}
                    </Button>
                    <Button variant="secondary" onClick={() => {
                        setSelectedVehicleIds([]);
                        setShowModalControl(false);
                    }}>
                        {t("RISK_AREA.CLOSE")}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{t("RISK_AREA.CONFIRM_DELETE")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {riskToDelete && (
                        <p>
                            {t("RISK_AREA.DELETE_MESSAGE")}{" "}
                            <strong>{riskToDelete.markerDescription}</strong>?
                        </p>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>
                        {t("RISK_AREA.CANCEL")}
                    </Button>
                    <Button variant="danger" onClick={confirmDelete}>
                        {t("RISK_AREA.DELETE")}
                    </Button>
                </Modal.Footer>
            </Modal>

            <div className="w-full" style={{ height: "100vh", overflow: "hidden" }}>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.05)',
                        borderRadius: '12px',
                        padding: '4px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        maxWidth: '300px',
                        margin: '12px auto'
                    }}
                >
                    <button
                        onClick={() => {
                            setActiveTab("grid");
                            setEditingItem(null);
                        }}
                        style={{
                            padding: '8px 20px',
                            border: 'none',
                            borderRadius: '8px',
                            backgroundColor: activeTab === "grid" ? 'var(--theme-primary)' : 'transparent',
                            color: activeTab === "grid" ? 'white' : '#6c757d',
                            fontWeight: activeTab === "grid" ? '600' : '500',
                            fontSize: '13px',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '6px',
                            boxShadow: activeTab === "grid" ? '0 2px 8px rgba(108, 92, 231, 0.3)' : 'none',
                            minWidth: '180px'
                        }}
                    >
                        <FaExclamationTriangle size={14} />
                        {t("RISK_AREA.POLYGON_FENCES")}
                    </button>

                    <button
                        onClick={() => setActiveTab("map")}
                        style={{
                            padding: '8px 20px',
                            border: 'none',
                            borderRadius: '8px',
                            backgroundColor: activeTab === "map" ? 'var(--theme-primary)' : 'transparent',
                            color: activeTab === "map" ? 'white' : '#6c757d',
                            fontWeight: activeTab === "map" ? '600' : '500',
                            fontSize: '13px',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '6px',
                            boxShadow: activeTab === "map" ? '0 2px 8px rgba(108, 92, 231, 0.3)' : 'none',
                            minWidth: '120px'
                        }}
                    >
                        {t("RISK_AREA.MAP")}
                    </button>
                </div>

                {activeTab === "map" && (
                    <div className="position-relative w-100">
                        <div
                            className="flex flex-col gap-4 shadow-lg rounded-lg"
                            style={{
                                zIndex: 10,
                                position: "absolute",
                                top: 80,
                                left: 20,
                                width: "360px",
                                padding: "20px",
                                background: "var(--bg-card)",
                                color: "var(--text-primary)",
                                borderRadius: 12,
                            }}
                        >
                            <div className="flex flex-col gap-1" style={{ marginBottom: 20 }}>
                                <label className="text-sm font-semibold text-gray-300">{t("RISK_AREA.SEARCH_ADDRESS")}:</label>
                                <input
                                    ref={inputRef}
                                    id="place"
                                    className="p-2 rounded"
                                    placeholder={t("RISK_AREA.ADDRESS_PLACEHOLDER")}
                                    disabled={!isEditing}
                                    style={{
                                        background: "var(--bg-primary)",
                                        border: "1px solid #374151",
                                        width: "300px",
                                        opacity: !isEditing ? 0.6 : 1,
                                        cursor: !isEditing ? "not-allowed" : "text"
                                    }}
                                />
                            </div>

                            <button
                                id="btnSearch"
                                onClick={handleSearch}
                                disabled={!isEditing}
                                className="px-3 py-2 rounded w-full text-white font-medium"
                                style={{
                                    background: "#2563eb",
                                    marginRight: 10,
                                    opacity: !isEditing ? 0.5 : 1,
                                    cursor: !isEditing ? "not-allowed" : "pointer"
                                }}
                            >
                                {t("RISK_AREA.SEARCH")}
                            </button>

                            <button
                                id="btnDraw"
                                onClick={handleDraw}
                                disabled={!isEditing || isDrawingMode}
                                className="px-3 py-2 rounded w-full text-white font-medium"
                                style={{
                                    background: isDrawingMode ? "#374151" : "#6b7280",
                                    marginBottom: isDrawingMode ? 4 : 20,
                                    opacity: !isEditing ? 0.5 : 1,
                                    cursor: !isEditing ? "not-allowed" : "pointer"
                                }}
                            >
                                {t("RISK_AREA.DRAW_POLYGON")}
                            </button>

                            {/* Instrução visual durante o desenho */}
                            {isDrawingMode && (
                                <div style={{
                                    background: "#1e3a5f",
                                    border: "1px solid #2563eb",
                                    borderRadius: 8,
                                    padding: "8px 12px",
                                    marginBottom: 12,
                                    fontSize: 12,
                                    color: "#93c5fd",
                                    lineHeight: 1.5,
                                }}>
                                    <strong>Modo de desenho ativo</strong><br />
                                    Clique no mapa para adicionar pontos.<br />
                                    Clique no <span style={{ color: "#ff6b6b" }}>ponto vermelho</span> para fechar o polígono.
                                    <br />
                                    <button
                                        onClick={stopDrawingMode}
                                        style={{
                                            marginTop: 6,
                                            background: "#dc2626",
                                            border: "none",
                                            borderRadius: 4,
                                            color: "white",
                                            padding: "2px 8px",
                                            fontSize: 11,
                                            cursor: "pointer"
                                        }}
                                    >
                                        Cancelar desenho
                                    </button>
                                </div>
                            )}

                            <label className="flex items-center gap-2 text-gray-300">
                                <input
                                    id="chkEdit"
                                    type="checkbox"
                                    disabled={!isEditing}
                                    onChange={handleToggleEdit}
                                    style={{
                                        accentColor: "#3b82f6",
                                        opacity: !isEditing ? 0.5 : 1,
                                        cursor: !isEditing ? "not-allowed" : "pointer"
                                    }}
                                />
                                <span style={{ marginRight: 8 }}>{t("RISK_AREA.EDIT_MODE")}</span>
                            </label>

                            {!isEditing && (
                                <button
                                    onClick={handleEnableEditing}
                                    className="px-3 py-2 rounded w-full text-white font-medium"
                                    style={{
                                        background: "#f59e0b",
                                        marginBottom: 10,
                                        marginRight: 10
                                    }}
                                >
                                    {t("RISK_AREA.EDIT")}
                                </button>
                            )}

                            {isEditing && (
                                <button
                                    id="btnCopy"
                                    onClick={() => {
                                        if (!activePolygonRef.current) {
                                            flashMsg("Desenhe um polígono antes de salvar.");
                                            return;
                                        }
                                        if (editingItem) {
                                            setMarkerDescription(editingItem.markerDescription || "");
                                        }
                                        setShowModal(true);
                                    }}
                                    className="px-3 py-2 rounded w-full text-white font-medium"
                                    style={{
                                        background: "#059669",
                                        marginRight: 10,
                                    }}
                                >
                                    {editingItem ? t("RISK_AREA.UPDATE_AREA") : t("RISK_AREA.SAVE_AREA")}
                                </button>
                            )}

                            <button
                                id="btnClear"
                                onClick={clearPolygon}
                                disabled={!isEditing}
                                className="px-3 py-2 rounded w-full text-white font-medium"
                                style={{
                                    background: "#dc2626",
                                    opacity: !isEditing ? 0.5 : 1,
                                    cursor: !isEditing ? "not-allowed" : "pointer"
                                }}
                            >
                                {t("RISK_AREA.CLEAR")}
                            </button>
                        </div>

                        <div ref={mapRef} id="map" className="w-100" style={{ height: "72vh" }} />
                    </div>
                )}

                {activeTab === "grid" && (
                    <div className="p-3" style={{ height: "calc(100vh - 100px)", overflowY: "auto" }}>
                        <GridComponent
                            dataSource={coordinatesList}
                            allowPaging={true}
                            pageSettings={{ pageSize }}
                        >
                            <ColumnsDirective>
                                <ColumnDirective
                                    headerText="Ponto de visita"
                                    width="25%"
                                    textAlign="Left"
                                    template={(data) => (
                                        <span>{data.markerDescription}</span>
                                    )}
                                />

                                <ColumnDirective
                                    headerText="Endereço"
                                    width="30%"
                                    textAlign="Left"
                                    template={(props) => (
                                        <a
                                            href={`https://maps.google.com/?q=${getLocationCoordinates("location", props)}`}
                                            target="_blank"
                                            rel="noreferrer"
                                            style={{
                                                cursor: "pointer",
                                                textDecoration: "underline",
                                                color: "inherit",
                                                fontSize: "13px",
                                            }}
                                        >
                                            <div>{props.address ?? props.location}</div>
                                        </a>
                                    )}
                                />

                                <ColumnDirective
                                    headerText="Vincular/Desvincular"
                                    width="20%"
                                    textAlign="Center"
                                    template={(data) => (
                                        <button
                                            className="btn btn-link"
                                            style={{ color: "var(--text-primary)" }}
                                            onClick={() => {
                                                setSelectedBindMarker(data);
                                                setShowModalControl(true);
                                            }}
                                        >
                                            <FaLink size={18} />
                                        </button>
                                    )}
                                />

                                <ColumnDirective
                                    headerText="Mapa"
                                    width="10%"
                                    textAlign="Center"
                                    template={(data) => (
                                        <button
                                            className="btn btn-link"
                                            style={{ color: "#4285F4" }}
                                            onClick={() => handleViewOnMap(data)}
                                        >
                                            <FaMapMarkerAlt color="red" size={20} />
                                        </button>
                                    )}
                                />

                                <ColumnDirective
                                    headerText="Editar"
                                    width="10%"
                                    textAlign="Center"
                                    template={(row) => (
                                        <button
                                            className="btn btn-link"
                                            style={{ color: "var(--text-primary)" }}
                                            onClick={() => handleParamEdit(row)}
                                        >
                                            <FaEdit size={18} />
                                        </button>
                                    )}
                                />

                                <ColumnDirective
                                    headerText={t("BUTTONS.DELETE")}
                                    width="10%"
                                    textAlign="Center"
                                    template={(row) => (
                                        <button
                                            className="btn btn-link"
                                            data-delete-action="true"
                                            aria-label="Excluir"
                                            style={{ color: "var(--text-primary)" }}
                                            onClick={() => openDeleteModal(row)}
                                        >
                                            <FaTrash size={18} />
                                        </button>
                                    )}
                                />
                            </ColumnsDirective>

                            <Inject services={[Page]} />
                        </GridComponent>
                    </div>
                )}

                <div id="msg" className="fixed right-3 bottom-3 bg-green-500 text-white px-3 py-2 rounded" style={{ display: "none" }}>
                    Copiado!
                </div>
            </div>
        </>
    );
}
